<template>
	<div class="wh">
		<div class="sideBar h fleft side-bar-page">
			<side-bar></side-bar>
		</div>
		<div class="mainContent h fright">
			<div class="mainContentNav" v-if="showHeader">
				<w-page-header></w-page-header>
			</div>
			<div class="mainContentMidden" :class="[{ 'p-main-content': showHeader }]">
				<keep-alive>
					<transition name="fade-transform" mode="out-in">
						<router-view ref="mychild" />
					</transition>
				</keep-alive>
			</div>
		</div>
		<common-screen :pageName="pageName" :show="IsScreen == 'No'" :name="name" :tabnum="tabnum"></common-screen>
		<common-screen-show :pageName="pageName" :show="IsScreenShow == 'No'"></common-screen-show>
		<div class="masku screenContent" style="background: rgba(0,0,0,0.4);" v-if="pressage">

			<el-progress type="circle" :percentage="percentage" class="prossage"></el-progress>
		</div>
	</div>
</template>

<script>
	import sideBar from '@/components/Sidebar.vue'

	export default {
		components: {
			sideBar,
			// navBar
		},
		props: {},
		data() {
			return {
				IsScreen: "Off", //筛选显隐控制
				IsScreenShow: "off", //展示字段筛选显隐控制
				pageName: "",
				menulist: "",
				parentnum:"",
				tabnum:"",
				pressage:false,
				percentage:50,
				name:"",

				showHeader: false
			}
		},
		computed: {},
		methods: {
			screenmask(data, n) {
				this.pageName = "";
				switch (n) {
					case "left1":
						this.IsScreen = data;
						break;
					case "right2":
						this.IsScreenShow = data;
						break;
					default:
						break;
				}

			},
			eventbus() {
				window.eventBus.$on("screenshow", (data) => {
					console.log('ab')
					console.log(data)
					this.pageName = data.pageName;
					this.name = data.name
					switch (data.num) {
						case "left1":
							this.IsScreen = data.showmask;
							break;
						case "right2":
							this.IsScreenShow = data.showmask;
							break;
						default:
							break;
					}
				})
			},
			tabchange(val){
				this.tabnum = val;
			},
			getaccess() {
				this.api.access({
					access_token:localStorage.getItem("access_token")
				}).then(da => {
					if(da.result == 0){
						localStorage.setItem("access",JSON.stringify(da.data));
					}
				})
			},
			categoryList() {
				//获取子组件表格数据
				var data = {
					access_token: localStorage.getItem("access_token"),
					page: 1,
					limit: 10000,
					status:1
				}

				this.api.categoryList(data).then((da) => {
					var child=[

					];
					da.data.forEach(item =>{
						child.push({
							name:item.category_name,
							id:item.id
						})
					})

					localStorage.setItem("child",JSON.stringify(child))
				}).catch(() => {

				});
			},
			setpercentage(status,url,id,coverurl){
				var time = "";
				if(status == "end"){
					this.percentage = 100;
					if(id == "con"){
						this.$refs.mychild.setcontent(url,coverurl);
					}else {
						this.$refs.mychild.setimgurl(url);
					}

					this.pressage=false;
					this.percentage = 50;
				}
				if(status == "start"){
					this.pressage=true;
					clearInterval(time);
					time = setInterval(()=>{
						if(this.percentage > 95){
							clearInterval(time);
						}
						this.percentage++;
					},0)
				}
			},
		},
		created() {
			this.getaccess();
		},
		mounted() {
			this.eventbus();
		},
		watch: {
			$route: {
				async handler(val) {
					let matched = val.matched
					let parentRoute = matched[matched.length - 2]
					let parentShowTabs = parentRoute && parentRoute.meta && parentRoute.meta.showTabs

					this.showHeader = val.meta.showHeader || parentShowTabs	
				},
				deep: true,
				immediate: true
			}
		}
	}
</script>
<style lang="scss">
@import "~styles/define.scss";

	$sideBarWidt: 60px;

	.sideBar {
		width: $sideBarWidt;
		background-color: $color-white;
	}

	.mainContent {
		width: calc(100% - 60px);
		background: $background-color-base;
		display: flex;
		flex-direction: column;
	}

	.mainContentNav {
		height: 60px;
		margin: 0 20px;
		margin-bottom: 10px;
	}

	.mainContentMidden {
		height: calc(100% - 0px);
		padding: 0px 20px 0px 20px;
	}

	.p-main-content{
		margin: 0 20px 10px;
		height: 100%;
		flex: 1;
		padding: 0;
		overflow: auto;
		background-color: $color-white;
	}

	.screenbg {
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
		width: 100%;
		height: 100%;
		z-index: 2040;
	}
</style>
